import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

import { StyledBrokerNameBase } from "../../styled";

export const StyledBrokerImage = styled.div`
    display: flex;
    align-items: center;
    width: 170px;
    height: 170px;

    img {
        width: 100%;
    }

    @media ${breakpoints.xs} {
        width: 90px;
        height: 90px;
    }
`;

export const StyledBrokerAddressContainer = styled.div`
    max-width: 35rem;

    .broker-address {
        margin-bottom: 0;
        font-size: var(--size-16);
        font-weight: normal;
        color: var(--color-grey-800);
        text-align: center;
        @media ${breakpoints.xs} {
            font-size: var(--size-12);
        }
    }

    .broker-sub-address {
        margin-top: 0;
        font-size: var(--size-16);
        font-weight: normal;
        color: var(--color-grey-800);
        text-align: center;
        @media ${breakpoints.xs} {
            font-size: var(--size-12);
        }
    }
`;

export const StyledBrokerName = styled.p`
    ${StyledBrokerNameBase}
`;
